import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import { AppConfigService } from '../../../Services/app-config.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import { ResponseModel } from '../../../DataModels/response-model';
import { PagerStateService } from '../../../Services/pager-state.service';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import { NgbpaginationConfigService } from '../../../Services/ngbpagination-config.service';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-timesheet-list',
  templateUrl: './timesheet-list.component.html',
  styleUrls: ['./timesheet-list.component.css'],
  standalone: false
})
export class TimesheetListComponent extends ListPageBase implements OnInit {
  vm: any = {
    title: $localize`:Timesheet List@@timesheetList:Timesheet List`,
    list: [],
    Preferences: [],
    permissions: [],
    listInitiated: false,
    formRoute: '/timesheet/timesheet-form',
  };

  isLoaded = false;

  constructor(
    private localStorage: StorageService,
    private titleService: Title,
    private tableDataService: DataService,
    private notification: BsToastService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle(this.vm.title);
    this.vm.list = [];
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));


    this.loadData();
  }

  protected fetchPage(): void {
    this.loadData();
  }

  loadData() {
    const paramString = '?pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0) + '&pageSize=' + this.pageSize;
    this.tableDataService.getApiListData('pr_timesheet', paramString).subscribe({
      next: (result: ResponseModel) => {
        this.vm.list = result.Data ?? [];
        this.totalRecords = result.totalRecords ?? 0;
        this.paginate(false);
        this.vm.listInitiated = true;
        this.isLoaded = true;
      },
      error: (err) => {
        console.error(err);
        this.notification.showErrorToast($localize`:Error loading timesheets@@errorLoadingTimesheets:Error loading timesheets`);
      },
    });
  }

  statusBadgeClass(status: string): string {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'submitted':
        return 'bg-warning';
      default:
        return 'bg-secondary';
    }
  }

  onNavigate(id: string) {
    this.router.navigate([this.vm.formRoute], {queryParams: {id}}).then();
  }

  serverSearch(value: any) {
    this.page = 1;
    this.loadData();
  }

  clearServerSearch(value: any) {
    this.page = 1;
    this.loadData();
  }
}
